/**
 * Application Configuration
 * Reads from environment variables to support multiple instances (ActiveOps, CHG, etc.)
 * 
 * Environment variables (prefixed with VITE_ for Vite):
 * - VITE_APP_NAME: Application name (e.g., "SmartCHG", "ActiveOps")
 * - VITE_APP_OWNER: Owner name (e.g., "CHG", "ActiveOps")
 * - VITE_PRIMARY_COLOR: Primary brand color (e.g., "#8d3165")
 * - VITE_SECONDARY_COLOR: Secondary brand color (e.g., "#722f37")
 * - VITE_ACCENT_COLOR: Accent color (e.g., "#f472b6")
 * - VITE_APP_ICON: Icon name for the application (e.g., "Zap", "Activity")
 */

export interface AppConfig {
  appName: string;
  ownerName: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  appIcon?: string; // Optional icon name
}

// Default values (SmartCHG)
const defaultConfig: AppConfig = {
  appName: 'SmartCHG',
  ownerName: 'CHG',
  primaryColor: '#8d3165', // Magenta Purple
  secondaryColor: '#722f37', // Wine/Burgundy
  accentColor: '#f472b6',
};

// Get configuration from environment variables with fallback to defaults
export const appConfig: AppConfig = {
  appName: import.meta.env.VITE_APP_NAME || defaultConfig.appName,
  ownerName: import.meta.env.VITE_APP_OWNER || defaultConfig.ownerName,
  primaryColor: import.meta.env.VITE_PRIMARY_COLOR || defaultConfig.primaryColor,
  secondaryColor: import.meta.env.VITE_SECONDARY_COLOR || defaultConfig.secondaryColor,
  accentColor: import.meta.env.VITE_ACCENT_COLOR || defaultConfig.accentColor,
  appIcon: import.meta.env.VITE_APP_ICON || undefined,
};

// Log configuration on load (for debugging)
if (import.meta.env.DEV) {
  console.log('[AppConfig] Loaded configuration:', {
    appName: appConfig.appName,
    ownerName: appConfig.ownerName,
    primaryColor: appConfig.primaryColor,
    secondaryColor: appConfig.secondaryColor,
    accentColor: appConfig.accentColor,
  });
}

